import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '@/components/Hero';
import Founder from '@/components/Founder';
import WhyItaly from '@/components/WhyItaly';
import Universities from '@/components/Universities';
import MBBSAbroad from '@/components/MBBSAbroad';
import Scholarships from '@/components/Scholarships';
import SuccessStories from '@/components/SuccessStories';
import Programs from '@/components/Programs';
import CareerPortalSection from '@/components/CareerPortalSection';

export const HomePage = () => {
  return (
    <>
      <Hero />
      <Founder />
      <WhyItaly />
      <Programs />
      <Universities limit={9} />
      <Scholarships />
      <CareerPortalSection />
      <MBBSAbroad />
      <SuccessStories limit={6} />
    </>
  );
};

export const ItalyPage = () => (
  <div style={{ paddingTop: '80px' }}>
    <WhyItaly />
    <Programs />
    <Universities />
    <Scholarships />
  </div>
);

export const MBBSPage = () => (
  <div style={{ paddingTop: '80px' }}>
    <MBBSAbroad />
  </div>
);

export const UniversitiesPage = () => (
  <div style={{ paddingTop: '80px' }}>
    <Universities />
  </div>
);

export const SuccessPage = () => (
  <div style={{ paddingTop: '80px' }}>
    <SuccessStories />
  </div>
);

export const ScholarshipsPage = () => (
  <div style={{ paddingTop: '80px' }}>
    <Scholarships />
  </div>
);

export const AboutPage = () => (
  <div style={{ paddingTop: '80px' }}>
    <Founder />
    <WhyItaly />
  </div>
);

// Auto-scroll-to-top on route change
export const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [pathname]);
  return null;
};
